import { render, staticRenderFns } from "./LegalCertificatStep1.vue?vue&type=template&id=43802bce&scoped=true&"
import script from "./LegalCertificatStep1.vue?vue&type=script&lang=js&"
export * from "./LegalCertificatStep1.vue?vue&type=script&lang=js&"
import style0 from "./LegalCertificatStep1.vue?vue&type=style&index=0&id=43802bce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43802bce",
  null
  
)

export default component.exports